import script from "./EnrollStudentStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollStudentStatus.vue?vue&type=script&setup=true&lang=js"

import "./EnrollStudentStatus.vue?vue&type=style&index=0&id=4f0b213e&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0b213e"]])

export default __exports__